import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";
import Nav from "./components/Nav";
import Footer from "./components/Footer";
import ConciergeChat from "./components/ConciergeChat";
import HomePage from "./pages/HomePage";
import {
  AboutPage, ProcessPage, ServicesPage, SpecialtiesPage,
  MembershipPage, ContactPage, LegalPage,
} from "./pages/Pages";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import { AuthProvider } from "./lib/auth";

function ScrollTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
  return null;
}

function AdminShell({ children }) { return <>{children}</>; }

function PublicShell({ children }) {
  return (
    <>
      <Nav />
      <main>{children}</main>
      <Footer />
      <ConciergeChat />
    </>
  );
}

function AppRoutes() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <>
      <ScrollTop />
      {isAdmin ? (
        <AdminShell>
          <Routes>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
        </AdminShell>
      ) : (
        <PublicShell>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/process" element={<ProcessPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/specialties" element={<SpecialtiesPage />} />
            <Route path="/membership" element={<MembershipPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/privacy" element={<LegalPage kind="privacy" />} />
            <Route path="/terms" element={<LegalPage kind="terms" />} />
            <Route path="/disclaimer" element={<LegalPage kind="disclaimer" />} />
            <Route path="*" element={<HomePage />} />
          </Routes>
        </PublicShell>
      )}
    </>
  );
}

export default function App() {
  return (
    <div className="App text-left">
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
          <Toaster
            position="top-center"
            toastOptions={{
              style: {
                background: "#0B1F3A",
                color: "#fff",
                border: "1px solid rgba(200,169,106,0.4)",
                borderRadius: 4,
                fontFamily: "Manrope, sans-serif",
              },
            }}
          />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
